import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";

// Get Table Data
export const HouseKeepingTableDataAPI = createAsyncThunk("HouseKeepingTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WS_PumpStationID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_HouseKeeping_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_PumpStationID=${M_WS_PumpStationID ? M_WS_PumpStationID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const HouseKeepingTableDataSlice = createSlice({
    name: "HouseKeepingTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(HouseKeepingTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(HouseKeepingTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(HouseKeepingTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const HouseKeepingTableDataReducer = HouseKeepingTableDataSlice.reducer

// -----------------Delete API ---------------

export const HouseKeepingDeleteAPI = createAsyncThunk("HouseKeepingDelete", async ({ data }) => {
    const {
        T_TTP_Water_HouseKeepingID,
        T_WS_HouseKeepingID,
        T_Distri_Water_HouseKeepingID,
        M_UserID,
        token,
        handleIsPost,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    // var formdata = new FormData();
    // formdata.append("T_WS_HouseKeepingID",T_WS_HouseKeepingID);
    // formdata.append("M_UserID", M_UserID);

    var formdata = new FormData();

    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_Water_HouseKeepingID", T_Distri_Water_HouseKeepingID);
    }else if (DashProjectTypeId == '9') {
        formdata.append("T_TTP_Water_HouseKeepingID", T_TTP_Water_HouseKeepingID);
    }else {
        formdata.append("T_WS_HouseKeepingID", T_WS_HouseKeepingID);
    }
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_Distri_Water_HouseKeeping_Delete`
    } else {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_WS_HouseKeeping_Delete`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const HouseKeepingDeleteSlice = createSlice({
    name: "HouseKeepingDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(HouseKeepingDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(HouseKeepingDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(HouseKeepingDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const HouseKeepingDeleteReducer = HouseKeepingDeleteSlice.reducer